import axios from 'axios';

import store from '@/store';
import baseConfig from '_config';
import sessionService from '_services/common/sessionService';

const stripTrailingSlash = (url = '') => url.replace(/\/+(?=([?#]|$))/, '');

const axiosInterceptor = () => {
  const apiUrl = stripTrailingSlash(baseConfig.API_URL);
  let exceptions = ['oauth/access_token'];

  exceptions = exceptions.map(e => `${apiUrl}/${e}`);

  // Add a request interceptor
  axios.interceptors.request.use(config => {
    config.url = stripTrailingSlash(config.url);

    if (config.url.startsWith(apiUrl)) {
      const token = sessionService.getLocalData('_token');

      if (token) {
        config.headers.common.Authorization = `Bearer ${token}`;
      }
    }

    if (!exceptions.includes(config.url)) {
      if (!store.state.toggle.progress) {
        store.dispatch('toggle', 'progress');
      }
    }
    return config;
  });

  // Add a response interceptor
  axios.interceptors.response.use(
    response => {
      if (!exceptions.includes(response.config.url)) {
        if (store.state.toggle.progress) {
          store.dispatch('toggle', 'progress');
        }
      }
      return response;
    },
    err => {
      if (store.state.toggle.progress) {
        store.dispatch('toggle', 'progress');
      }

      return Promise.reject(err);
    }
  );
};

export default axiosInterceptor;
